import React, { useState, useEffect, useRef } from "react";
import "./CourseEdit.scss";
import EditableChapter from "./EditableChapter";
import Dependent from "../../Dependent";
import axiosInstance from "../../../../../../../axios";
import { isNullOrEmpty } from "../../../../../../../_helpers";
import { debounce } from "lodash";
import { Loading } from "../../../../../../Other/Loading";
import EditSubmit from "./EditSubmit";
import CourseImageUpload from "../../../CourseImageUpload";
import CourseVideoUpload from "../../../CourseVideoUpload";
import OverlayContainer from "@components/Overlay/OverlayContainer";
import CoursePreview from "../../../../../../Courses/CoursePreview/CoursePreview";
import { getS3URL } from "../../../../../../../_helpers";
import { CourseBuilderStaticData } from "../../../../../../../_constants/staticData";
import Quiz from "../Quiz";
import WebinarScheduler from "../WebinarSchedular";
import TextEditor from "../TextEditor";
import CreateBundle from "../../../CreateBundle";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import moment from "moment/moment";
import CourseFile from "../../../CourseFileUpload";
import { px } from "framer-motion";

const { REACT_APP_LOGIN_API_BASEURL } = process.env;

const CourseEdit = (props) => {
  const editImageRef = useRef();
  const location = useLocation();
  const params = useParams()
  const navigate = useNavigate();
  // const courseId = location?.state?.courseId;
  const courseId = params?.id;
  const bundle = location?.state?.bundle;
  const param = useParams();
  const [selectedSyllabus, setSelectedSyllabus] = useState({
    id: '',
    name: ''
  })
  const [formValues, setFormValues] = useState({
    id: "",
    courseType: "",
    courseName: "",
    category: "",
    subCategory: "",
    courseOneLiner: "",
    IsAdult: "0",
    goals: [{ name: "" }, { name: "" }],
    preRequisites: [{ name: "" }],
    description: null,
    courseOutDescription: null,
    status: "",
    faqs: [{ question: "", answer: "" }],
    syllabus: [],
    syllabusFile: null,
    Syallbus: [],
    level: "",
    language: "",
    duration: "",
    courseDate: "",
    imageFiles: [],
    videoFiles: [],
    courses: [],
    courseSections: [
      {
        // mainTitle: "",
        sectionName: "",
        sectionDescription: null,
        files: [],
        scroms: [],
        videoLink: "",
        syllabusName: selectedSyllabus.name || "",
        syllabusId: selectedSyllabus.id || "",
      },
    ],
    isFree: false,
    currency: "",
    enrollmentFee: 0,
    promotionalOffer: false,
    promotionalCode: "",
    discountPercent: "",
  });

  const [editImage, setEditImage] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [numError, setNumError] = useState("");
  const [showCoursePreview, setShowCoursePreview] = useState(false);
  const [quizCreation, setQuizCreation] = useState({
    name: "",
    guidelines: "",
    id: courseId,
    questions: [
      {
        question: null,
        type: null,
        answers: [{ answer: "", isRight: false }],
      },
    ],
  });
  const [showMore, setShowMore] = useState(false);
  const [showMoreHighlight, setShowMoreHighlight] = useState(false);
  const [showMoreSyllabus, setShowMoreSyllabus] = useState(false);
  const [showMoreFaqs, setShowMoreFaqs] = useState(false);
  const [updateQuizResponse, setUpdateQuizResponse] = useState();
  const [isFetching, setIsFetching] = useState(true);
  const [errors, setErrors] = useState({
    goals: [],
    preRequisites: [],
    faqs: [],
    syllabus: [],
    courseSections: [],
  });

  const [quizResponse, setQuizResponse] = useState(false);
  const [quizStatus, setQuizStatus] = useState(false);
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [success, setSuccess] = useState(false);
  const [isQuizPopupVisible, setIsQuizPopupVisible] = useState(false);
  const [quizValidateMsg, setQuizValidateMsg] = useState(false);
  const [warning, setWarning] = useState(false);
  const [stateShow, setStateShow] = useState({
    Title: false,
    video: false,
    meetingDescription: false,
    invites: false,
    Highlights: false,
    Requirement: false,
    description: false,
    courseOutDescription: false,
    Faqs: false,
    courseOneLiner: false,
    category: true,
    Syallbus: false,
    level: true,
    courseDate: false,
    language: false,
    duration: false,
    price: false,
    saveall: false,
    submit: false,
    cancel: false,
    quiz: false,
    WebinarScheduler: false,
    selectedCourse: false,
  });
  const [editedCourseResponse, setEditedCourseResponse] = useState(null);
  const selectLevelOptions = [
    { value: "Beginner", label: "Beginner" },
    { value: "Intermediate", label: "Intermediate" },
    { value: "Expert", label: "Expert" },
    { value: "Pro", label: "Pro" },
  ];


  const CourseFileHandler = (files) => {
    //fileHandler(files, fileData.courseSectionId, fileData.fileNumber);
    console.log("files in CourseEdit.js", files);
    if (files.length > 0) {
      setFormValues({
        ...formValues,
        Syallbus: files,
        syllabusFile: files[0].originalName || files[0].name,
      });
    } else {
      setFormValues({ ...formValues, Syallbus: [], syllabusFile: null });
    }
  };
  const chooseLanguageOptions = [
    { value: "English", label: "English" },
    { value: "Spanish", label: "Spanish" },
    { value: "French", label: "French" },
    { value: "Russian", label: "Russian" },
    { value: "Hindi", label: "Hindi" },
    { value: "Russian", label: "Russian" },
    { value: "Portuguese", label: "Portuguese" },
    { value: "Indonesian", label: "Indonesian" },
    { value: "Japanese", label: "Japanese" },
    { value: "Chinese", label: "Chinese" },
    { value: " Mandarin Chinese", label: " Mandarin Chinese" },
  ];
  const fetchAll = async () => {
    try {
      let res;

      if (bundle) {
        res = await axiosInstance.get(`${REACT_APP_LOGIN_API_BASEURL}/v2/bundles/${courseId}`);

        setFormValues({
          id: res?.data?.data?.id,
          courseName: res?.data?.data?.name,
          description: res?.data?.data?.description,
          duration: res?.data?.data?.duration,
          courseDate: res?.data?.data?.courseDate,
          enrollmentFee: res?.data?.data?.price,
          imageFiles: [res?.data?.data?.imageLink],
          courses: res?.data?.data?.courses,
          goals: res?.data?.data?.goals[0],
          faqs: res?.data?.data?.faqs[0],
          preRequisites: res?.data?.data?.preRequisites[0],
          level: res?.data?.data?.level,
          language: res?.data?.data?.language,
          courseOneLiner: res?.data?.data?.bundleOneLiner,
        });
      } else {
        res = await axiosInstance.get(`course/${courseId || param.id}`);
        console.log("course fetch res", res?.data?.data);
        setFormValues(mapApiResponseToState(res?.data?.data));
      }

    } catch (error) {
      console.error("Error fetching course or bundle data:", error.message);
    } finally {
      setIsFetching(false);
    }
  };


  useEffect(() => {
    fetchAll();
  }, []);

  const mapApiResponseToState = (courseResponseData) => {
    return {
      id: courseResponseData.ID,
      courseType: courseResponseData.courseType,
      courseName: courseResponseData.CourseName,
      category: courseResponseData.category,
      subCategory: courseResponseData.SubCategory,
      courseOneLiner: courseResponseData.courseOneLiner,
      IsAdult: courseResponseData.IsAdult,
      courseOutDescription: courseResponseData.courseOutDescription,
      goals:
        courseResponseData.goals.length === 0
          ? [{ name: "" }, { name: "" }]
          : courseResponseData.goals,
      preRequisites:
        courseResponseData.preRequisites.length === 0
          ? [{ name: "" }]
          : courseResponseData.preRequisites,
      description: courseResponseData.Description
        ? courseResponseData.Description
        : courseResponseData.Description,
      faqs:
        courseResponseData.faqs.length === 0
          ? [{ question: "", answer: "" }]
          : courseResponseData.faqs,

      syllabus: courseResponseData.syllabus || [],
      syllabusFile: (() => {
        const syllabusFileObj = courseResponseData.courseFiles?.find(
          (file) => file.courseDetailId === 0 || file.courseDetailId === null || file.courseDetailId === "0"
        );
        return syllabusFileObj ? syllabusFileObj.originalName : null;
      })(),
      Syallbus: courseResponseData.courseFiles?.filter(
        (file) => file.courseDetailId === 0 || file.courseDetailId === null || file.courseDetailId === "0"
      ) || [],
      status: courseResponseData.Status === 1 ? 2 : courseResponseData.Status,
      level: courseResponseData.Level,
      language: courseResponseData.Language,
      duration: courseResponseData.Duration,
      courseDate: courseResponseData.courseDate,
      imageFiles: courseResponseData.imageFiles,
      videoFiles: courseResponseData.videoFiles,
      courseSections: courseResponseData?.courseSections?.map((section) => ({
        ...section,
        // mainTitle: section.mainTitle || "",
        name: section.sectionName,
        description: section.sectionDescription
          ? section.sectionDescription
          : section.sectionDescription,
        id: section.id,
        isEdit: true,
        syllabusName: section.syllabusName || "",
        syllabusId: section.syllabusId || "",

      })),
      isFree: courseResponseData.IsFree,
      currency: courseResponseData.Currency,
      enrollmentFee: courseResponseData.EnrollmentFee,
      promotionalOffer: courseResponseData.PromotionalOffer,
      promotionalCode: courseResponseData.PromotionalCode,
      discountPercent: courseResponseData.DiscountPercent,

    };
  };

  const numberOfItems = showMore ? formValues?.goals.length : 2;
  const numberOfHighlight = showMoreHighlight
    ? formValues?.preRequisites?.length
    : 2;
  const numberOfSyllabus = showMoreSyllabus ? formValues?.syllabus?.length : 2;
  const numberOfFaqs = showMoreFaqs ? formValues?.faqs?.length : 2;

  const handleExpand = () => {
    setShowMore(!showMore);
  };

  const handleHighlightExpand = () => {
    setShowMoreHighlight(!showMoreHighlight);
  };

  const handleSyllabusExpand = () => {
    setShowMoreSyllabus(!showMoreSyllabus);
  };

  const handleFaqsExpand = () => {
    setShowMoreFaqs(!showMoreFaqs);
  };

  const handleInputChange = (index, name, value, accessor = null) => {
    //console.log("handleInputChange", index, name, value, accessor);
    let clonedValues = [...formValues[name]];
    //console.log("clonedValues", clonedValues);
    setFormValues({
      ...formValues,
      [name]: bindFormValues(index, value, clonedValues, accessor),
    });
  };

  useEffect(() => {
    //console.log("formValues changed", formValues);
  }, [formValues]);

  const bindFormValues = (index, value, items, accessor = null) => {
    accessor ? (items[index][accessor] = value) : (items[index] = value);
    return items;
  };

  const canAddMoreFields = (
    formData,
    errors,
    property,
    max,
    isNested = null
  ) => {
    let isValid = isNested
      ? formData[property].every((item) =>
        Object.values(item).every((value) => isNullOrEmpty(value))
      )
      : formData[property].every((item) => isNullOrEmpty(item));
    return (
      isValid &&
      formData[property].length < max &&
      errors[property].every((item) => item.valid)
    );
  };

  const addFormFields = (
    event,
    property,
    max,
    prevState,
    errors,
    value = "",
    accessor = null
  ) => {
    event.preventDefault();
    if (canAddMoreFields(prevState, errors, property, max, accessor)) {
      setFormValues({
        ...formValues,
        [property]: [...formValues[property], value],
      });
    }
  };

  const isDuplicate = (input, items) =>
    items.some(
      (item) => item.name.toLowerCase() === input.trim().toLowerCase()
    );

  const validateDuplicateText = (value, index, property, items) => {
    if (isNullOrEmpty(value) && isDuplicate(value, items)) {
      setErrors({
        ...errors,
        [property]:
          errors[property].filter((item) => item.id === index).length > 0
            ? errors[property]
            : [...errors[property], { id: index, vaild: false }],
      });
    } else {
      setErrors({
        ...errors,
        [property]: [...errors[property].filter((item) => item.id !== index)],
      });
    }
  };

  const removeFormFields = (event, index, property) => {
    event.preventDefault();
    let newFormValues = [...formValues[property]];
    newFormValues.splice(index, 1);
    setFormValues({ ...formValues, [property]: newFormValues });
  };

  const handle = ({ name, value }) => {
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };

  const handleEditorStateChange = (name, accessor = null, index = null) =>
    debounce((editorState) => {
      setFormValues((state) => ({
        ...state,
        [name]: bindEditorState(
          accessor,
          index,
          editorState,
          !bundle && [...state.courseSections]
        ),
      }));
    }, 500);

  const bindEditorState = (accessor, index, editorState, items) => {
    if (accessor) {
      items[index][accessor] = editorState;
      return items;
    } else {
      return editorState;
    }
  };

  const EditSubmitHandler = () => {
    setStateShow({ ...stateShow, saveall: true });
    setWarning(!warning);
  };

  const closeHandler = (value) => {
    setStateShow({ ...stateShow, saveall: value });
    setWarning(value);
  };

  const SubmitHandler = async () => {
    setEditedCourseResponse("");
    setStateShow({ ...stateShow, saveall: true });
    setIsPopupVisible(true);

    const url = `course/${formValues.id}`;

    const payload =
      formValues.courseType !== "liveCourse"
        ? {
          ...formValues,
          description: formValues.description || formValues.description,
          courseName: formValues.courseName,
          courseSections: formValues.courseSections,
          preRequisites:
            formValues.preRequisites[0]?.name === ""
              ? []
              : formValues.preRequisites,
        }
        : {
          id: formValues.id,
          courseType: formValues.courseType,
          description: formValues.description || formValues.description,
          courseName: formValues.courseName,
          category: formValues.category,
          subCategory: formValues.subCategory,
          imageFiles: formValues.imageFiles,
          isFree: formValues.isFree,
          currency: formValues.currency,
          enrollmentFee: formValues.enrollmentFee,
          level: formValues.level,
          status: 2,
        };
    //console.log("payload", payload, url);
    try {
      const res = await axiosInstance.put(url, JSON.stringify(payload), {
        headers: {
          "Content-Type": "application/json",
        },
      });

      setEditedCourseResponse(res?.data);
      setIsPopupVisible(false);
      setSuccess(true);
    } catch (error) {
      console.error("Error updating course:", error.message);
    }
  };


  const SubmitHandlerBundle = async () => {
    setEditedCourseResponse("");
    setStateShow({ ...stateShow, saveall: true });
    setIsPopupVisible(true);

    const url = `${REACT_APP_LOGIN_API_BASEURL}/v2/bundles/${formValues.id}`;

    const payload = {
      name: formValues.courseName,
      description: formValues.description,
      duration: formValues.duration,
      price: formValues.enrollmentFee,
      courses: formValues?.courses?.map((ele) => ele.ID),
      imageLink: formValues.imageFiles[0],
      goals: formValues.goals,
      faqs: formValues.faqs,
      preRequisites: formValues.preRequisites,
      level: formValues.level,
      language: formValues.language,
      bundleOneLiner: formValues.courseOneLiner,
    };

    try {
      const res = await axiosInstance.put(url, JSON.stringify(payload), {
        headers: {
          "Content-Type": "application/json",
        },
      });

      setEditedCourseResponse(res?.data);
      setIsPopupVisible(false);
      setSuccess(true);
    } catch (error) {
      console.error("Error updating bundle:", error.message);
    }
  };


  const handledependent = ({ name, value }) => {
    setFormValues((state) => ({
      ...state,
      [name]: value,
    }));
  };

  const courseImageFile = (content) => {
    if (content.length > 0) readImageFile(content);
  };
  const readImageFile = (file) => {
    let temp = [];
    file.forEach((element, index) => {
      const reader = new FileReader();
      reader.onload = function (e) {
        const Testing = element.name;
        const extension = Testing.split(".").pop();
        const Filename = Testing.split(".").slice(0, -1).join(".");
        temp.push({
          isUpdated: true,
          fileName: Filename,
          base64: reader.result,
          fileExt: extension,
          fileSize: element.size,
        });
        setFormValues({ ...formValues, imageFiles: temp });
      };
      reader.readAsDataURL(element);
    });
  };

  const handleEdit = () => {
    setEditImage((state) => !state);
  };

  const renderCourseImage = (files) => {
    return (
      <div class="flex items-center justify-center w-full h-full">
        <img
          alt="test"
          src={
            files && files.length > 0
              ? getS3URL(files[0].fileName)
              : getS3URL("UI/icons/icon-brokenImg.svg")
          }
          className="header-Mycourse-detailsSection-img"
        />
      </div>
    );
  };

  const courseVideoFile = (content) => {
    if (content.length > 0) {
      setFormValues({
        ...formValues,
        videoFiles: [...formValues.videoFiles, content],
      });
    } else {
      setFormValues({ ...formValues, videoFiles: [] });
    }
  };

  const handleCoursePreview = (event) => {
    event.preventDefault();
    setShowCoursePreview(!showCoursePreview);
  };
  const courseFile = (sectionIndex, formValues) => (content) => {
    if (content != null && typeof content == "object" && content.length > 0) {
      const lastIndex = content.length - 1;
      const currentSectionData = content[lastIndex];

      if (currentSectionData?.type === "application/x-zip-compressed") {
        const previousCourseSection = [...formValues.courseSections];
        previousCourseSection[sectionIndex].scroms.push(currentSectionData);
        setFormValues({
          ...formValues,
          courseSections: previousCourseSection,
        });
      }
      if (currentSectionData?.type !== "application/x-zip-compressed") {
        const previousCourseSection = [...formValues.courseSections];
        previousCourseSection[sectionIndex].files.push(currentSectionData);
        setFormValues({
          ...formValues,
          courseSections: previousCourseSection,
        });
      }
    }
  };

  const quizCentalizeData = (values) => {
    return {
      status: 1,
      name: values.name,
      guidelines: values.guidelines,
      id: values.id,
      questions: values.questions.map((items) => ({
        id: items.id,
        question: items.question,
        type: items.type,
        answers: items.options.map((elements) => ({
          answer: elements.answer,
          id: elements.id,

          isRight: elements.isRight === 0 ? false : true,
        })),
      })),
    };
  };

  const handleraccordion = () => {
    setIsActive(!isActive);
  };
  const handleChangeEdit = () => {
    navigate('/dashboard/Quizs')
  };

  useEffect(() => {
    const fetchQuizData = async () => {
      try {
        const res = await axiosInstance.get(`/quiz/${courseId}`);
        if (res.data.data.length > 0) {
          setQuizCreation(quizCentalizeData(res.data.data[0]));
          setQuizStatus(true);
        } else {
          setQuizCreation(quizCreation); // fallback to default
        }
      } catch (error) {
        console.error("Error fetching quiz data:", error.message);
      }
    };

    fetchQuizData();
  }, [courseId]);


  const quizSubmitHandler = async () => {
    setQuizResponse(true);

    try {
      let res;
      if (quizStatus) {
        res = await axiosInstance.post(`/quiz/${quizCreation.id}`, quizCreation);
      } else {
        res = await axiosInstance.post("/quiz", quizCreation);
      }

      setUpdateQuizResponse(res.data.message);
      setQuizResponse(false);
      setIsQuizPopupVisible(true);

    } catch (error) {
      console.error("Error submitting quiz:", error.message);
      setQuizResponse(false);
    }
  };


  const checkIfNumber = (event) => {
    const regex = new RegExp(
      /(^\d*$)|(Backspace|Tab|Delete|ArrowLeft|ArrowRight)/
    );

    if (!event.key.match(regex)) {
      setNumError("*Please enter a number ");
    } else {
      setNumError("");
    }

    return !event.key.match(regex) && event.preventDefault();
  };

  return (
    <>
      {isFetching ? (
        <div className="edit-loading">
          <Loading />
        </div>
      ) : (
        formValues && (
          <>
            <section className="container-wrapper">
              {!editImage ? (
                <>
                  {bundle ? (
                    <div className="header-Mycourse-detailsSection">
                      <img
                        src={
                          formValues?.imageFiles
                            ? getS3URL(formValues.imageFiles[0])
                            : getS3URL("UI/icons/icon-brokenImg.svg")
                        }
                        className="header-Mycourse-detailsSection-img"
                      />
                      <img
                        src={`${process.env.REACT_APP_SMIK_API_BASEURL}/icons/icon-photo-camera.svg`}
                        className="header-Mycourse-detailsSection-play"
                        alt="play-button"
                        onClick={handleEdit}
                      />
                    </div>
                  ) : (
                    <div className="header-Mycourse-detailsSection">
                      {renderCourseImage(formValues.imageFiles)}
                      <img
                        src={`${process.env.REACT_APP_SMIK_API_BASEURL}/icons/icon-photo-camera.svg`}
                        className="header-Mycourse-detailsSection-play"
                        alt="play-button"
                        onClick={handleEdit}
                      />
                    </div>
                  )}
                </>
              ) : (
                <>
                  <div className="courseimageuploadcancel">
                    <i className="icon check" onClick={handleEdit}></i>
                  </div>
                  <div className="course-imageEdit">
                    <CourseImageUpload
                      courseImageFileLimit={1}
                      courseImageFile={courseImageFile}
                      editImageRef={editImageRef}
                      history={props.history}
                      courseId={courseId}
                      uploadedFileID={
                        formValues.imageFiles.length > 0
                          ? formValues.imageFiles[0].id
                          : 0
                      }
                    />
                  </div>
                </>
              )}

              <div className="Mycourse-detailsSection-btn align-items-center">
                <button className="cancelChange" onClick={EditSubmitHandler}>
                  Cancel All Changes
                </button>
                <button
                  className="saveChange"
                  onClick={bundle ? SubmitHandlerBundle : SubmitHandler}
                >
                  Save All Changes
                </button>
              </div>

              <div className="main-myCourseDetails">
                <div className="editContainer">
                  <button
                    className="courseEdit-content"
                    onClick={() =>
                      setStateShow((stateShow) => ({
                        ...stateShow,
                        Title: !stateShow.Title,
                      }))
                    }
                  >
                    {stateShow.Title ? "Update -" : " Edit +"}
                  </button>

                  <div className="edit-section-title">Title</div>
                  <ul>
                    {stateShow.Title === false ? (
                      <li>{formValues.courseName}</li>
                    ) : (
                      <></>
                    )}
                  </ul>
                  {stateShow.Title && (
                    <div className="courseGetContent-subClass">
                      <input
                        type="text"
                        name="courseName"
                        value={formValues.courseName}
                        onChange={({ target }) => handle(target)}
                      />
                    </div>
                  )}
                </div>

                {formValues.courseType !== "liveCourse" && (
                  <>
                    {!bundle && (
                      <div className="editContainer">
                        <button
                          className="courseEdit-content"
                          onClick={() =>
                            setStateShow((stateShow) => ({
                              ...stateShow,
                              video: !stateShow.video,
                            }))
                          }
                        >
                          {stateShow.video ? "Update -" : " Edit +"}
                        </button>

                        <div className="edit-section-title">Course Trailer</div>
                        <ul>
                          {stateShow.video === false && formValues?.videoFiles?.length > 0 ? (
                            <>
                              {formValues.videoFiles[0]?.fileName && (
                                <li>
                                  <video
                                    width="320"
                                    height="180"
                                    controls
                                    onClick={handleCoursePreview}
                                  >
                                    <source
                                      src={`${process.env.REACT_APP_SMIK_API_BASEURL}/UI/videos/${formValues.videoFiles[0].fileName}`}
                                      type="video/mp4"
                                    />
                                    Your browser does not support the video tag.
                                  </video>
                                </li>
                              )}
                            </>
                          ) : (
                            formValues?.videoFiles?.length < 1 && (
                              <span style={{ color: "#000000", fontWeight: 500 }}>
                                Please upload Course Trailer
                              </span>
                            )
                          )}
                        </ul>

                        {stateShow.video === true && (
                          <div className="courseGetContent-subClass">
                            <CourseVideoUpload
                              courseVideoFileLimit={1}
                              courseVideoFile={courseVideoFile}
                              history={props.history}
                              uploadedFileID={
                                formValues.videoFiles.length > 0
                                  ? formValues.videoFiles[0].id
                                  : 0
                              }
                            />
                          </div>
                        )}
                      </div>
                    )}

                    <div className="editContainer li-list-style-square">
                      <button
                        className="courseEdit-content"
                        onClick={() =>
                          setStateShow((stateShow) => ({
                            ...stateShow,
                            Highlights: !stateShow.Highlights,
                          }))
                        }
                      >
                        {stateShow.Highlights ? "Update -" : "Edit +"}
                      </button>

                      <div className="edit-section-title">Course Goals</div>
                      <ul>
                        {stateShow && stateShow.Highlights === false && (
                          <>
                            {formValues &&
                              formValues.goals[0]?.name !== "" &&
                              formValues.goals.length > 0 &&
                              formValues.goals
                                .slice(0, numberOfItems)
                                .map((items, index) => (
                                  <li key={index}>{items.name}</li>
                                ))}
                          </>
                        )}
                      </ul>
                      {stateShow.Highlights === false && (
                        <>
                          {formValues.goals[0]?.name === "" && (
                            <span style={{ color: "#000000", fontWeight: 500 }}>
                              Please fill out Course goals
                            </span>
                          )}
                        </>
                      )}

                      {stateShow && stateShow.Highlights && (
                        <div className="define-add-input">
                          {formValues &&
                            formValues.goals &&
                            formValues.goals.map((item, index) => (
                              <>
                                <div className="form-inline" key={index}>
                                  <input
                                    type="text"
                                    name="goals"
                                    placeholder="Define goals"
                                    value={item.name}
                                    className={
                                      errors.goals.filter(
                                        (item) => item.id === index
                                      ).length > 0
                                        ? "error"
                                        : ""
                                    }
                                    onChange={({ target }) =>
                                      handleInputChange(
                                        index,
                                        target.name,
                                        target.value,
                                        "name"
                                      )
                                    }
                                    onBlur={({ target }) =>
                                      validateDuplicateText(
                                        target.value,
                                        index,
                                        target.name,
                                        [
                                          ...formValues.goals.filter(
                                            (_, i) => i !== index
                                          ),
                                        ]
                                      )
                                    }
                                    disabled={
                                      errors.goals.length > 0 &&
                                      errors.goals.some(
                                        (item) => item.id !== index
                                      )
                                    }
                                  />
                                  <div className="input-validations">
                                    {errors.goals.some(
                                      (item) => item.id === index
                                    ) && (
                                        <span className="input-error">
                                          Duplicate text
                                        </span>
                                      )}
                                  </div>

                                  {formValues &&
                                    formValues.goals.length > 2 &&
                                    formValues.goals.length === index + 1 && (
                                      <div className="define-add-text align-remove-text">
                                        <img
                                          name="goals"
                                          role="button"
                                          href="javascript(void);"
                                          onClick={(event) =>
                                            removeFormFields(
                                              event,
                                              index,
                                              event.target.name
                                            )
                                          }
                                          src={`${process.env.REACT_APP_SMIK_API_BASEURL}/icons/icon-trash.svg`}
                                          alt=""
                                        />
                                      </div>
                                    )}
                                </div>
                              </>
                            ))}
                          <div className="define-add-text">
                            <a
                              href="javascript(void);"
                              onClick={(event) =>
                                addFormFields(
                                  event,
                                  "goals",
                                  10,
                                  {
                                    ...formValues,
                                    goals: formValues.goals.map(({ name }) => ({
                                      name,
                                    })),
                                  },
                                  errors,
                                  { name: "" },
                                  true
                                )
                              }
                            >
                              + Add More Fields
                            </a>
                          </div>
                        </div>
                      )}

                      {stateShow && stateShow.Highlights === false && (
                        <>
                          {formValues.goals.length > 2 && (
                            <button
                              className="exapnd-courseHighLights"
                              onClick={handleExpand}
                            >
                              {showMore ? "- Read less" : "+ Read more"}
                            </button>
                          )}
                        </>
                      )}
                    </div>

                    <div className="editContainer">
                      <button
                        className="courseEdit-content"
                        onClick={() =>
                          setStateShow((stateShow) => ({
                            ...stateShow,
                            courseOneLiner: !stateShow.courseOneLiner,
                          }))
                        }
                      >
                        {stateShow.courseOneLiner ? "Update -" : "Edit +"}
                      </button>

                      <div className="edit-section-title">
                        Course One Linear (optional)
                        <ul>
                          {stateShow.courseOneLiner === false ? (
                            <li>{formValues.courseOneLiner}</li>
                          ) : (
                            <></>
                          )}
                        </ul>
                        {stateShow.courseOneLiner === true && (
                          <div className="courseGetContent-subClass">
                            <input
                              type="text"
                              name="courseOneLiner"
                              value={formValues.courseOneLiner}
                              onChange={({ target }) => handle(target)}
                            />
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="editContainer">
                      <button
                        className="courseEdit-content"
                        onClick={() =>
                          setStateShow((stateShow) => ({
                            ...stateShow,
                            Requirement: !stateShow.Requirement,
                          }))
                        }
                      >
                        {stateShow.Requirement ? "Update -" : "Edit +"}
                      </button>

                      <div className="edit-section-title">
                        Course preRequisites (optional)
                      </div>
                      <ul>
                        {stateShow && stateShow.Requirement === false && (
                          <>
                            {formValues.preRequisites &&
                              formValues.preRequisites[0]?.name !== "" &&
                              formValues.preRequisites
                                .slice(0, numberOfHighlight)
                                .map((items, index) => (
                                  <li key={index}>{items.name}</li>
                                ))}
                          </>
                        )}
                        {formValues.preRequisites.length > 2 && (
                          <button
                            className="exapnd-courseHighLights"
                            onClick={handleHighlightExpand}
                          >
                            {showMoreHighlight ? "- Read less" : "+ Read more"}
                          </button>
                        )}
                      </ul>

                      {stateShow && stateShow.Requirement === true && (
                        <div className="define-add-input">
                          {formValues &&
                            formValues.preRequisites.map((item, index) => (
                              <div className="form-inline" key={index}>
                                <input
                                  type="text"
                                  className={
                                    errors.preRequisites.filter(
                                      (item) => item.id === index
                                    ).length > 0
                                      ? "error"
                                      : ""
                                  }
                                  name="preRequisites"
                                  placeholder="Pre-requisites or qualification for this course"
                                  value={item.name}
                                  maxLength={120}
                                  onChange={({ target }) =>
                                    handleInputChange(
                                      index,
                                      target.name,
                                      target.value,
                                      "name"
                                    )
                                  }
                                  onBlur={({ target }) =>
                                    validateDuplicateText(
                                      target.value,
                                      index,
                                      target.name,
                                      [
                                        ...formValues.preRequisites.filter(
                                          (_, i) => i !== index
                                        ),
                                      ]
                                    )
                                  }
                                  disabled={
                                    errors.preRequisites.length > 0 &&
                                    errors.preRequisites.some(
                                      (item) => item.id !== index
                                    )
                                  }
                                />
                                <span>
                                  Character remaining {120 - item.name.length}{" "}
                                </span>

                                {index > 0 && (
                                  <img
                                    href="javascript(void);"
                                    name="preRequisites"
                                    className="align-textRemove"
                                    onClick={(event) =>
                                      removeFormFields(
                                        event,
                                        index,
                                        event.target.name
                                      )
                                    }
                                    src={`${process.env.REACT_APP_SMIK_API_BASEURL}/icons/icon-trash.svg`}
                                    alt=""
                                  />
                                )}
                              </div>
                            ))}
                          <div className="define-add-text">
                            <a
                              href="javascript(void);"
                              onClick={(event) =>
                                addFormFields(
                                  event,
                                  "preRequisites",
                                  10,
                                  {
                                    ...formValues,
                                    preRequisites: formValues.preRequisites.map(
                                      ({ name }) => ({
                                        name,
                                      })
                                    ),
                                  },
                                  errors,
                                  { name: "" },
                                  true
                                )
                              }
                            >
                              + Add More Fields
                            </a>
                          </div>
                        </div>
                      )}
                    </div>
                  </>
                )}

                {!bundle && (
                  <div className="editContainer">
                    <button
                      className="courseEdit-content"
                      onClick={() =>
                        setStateShow((stateShow) => ({
                          ...stateShow,
                          courseOutDescription: !stateShow.courseOutDescription,
                        }))
                      }
                    >
                      {stateShow.courseOutDescription ? "Update -" : "Edit +"}
                    </button>

                    <div className="edit-section-title">
                      {/* course Out Description */}
                      Skilled Cover
                    </div>
                    <ul>
                      {stateShow.courseOutDescription === false &&
                        formValues.courseOutDescription !== "" && (
                          <li>
                            {formValues.courseOutDescription && (
                              <div
                                className="rich-text"
                                dangerouslySetInnerHTML={{
                                  __html: formValues.courseOutDescription,
                                }}
                              ></div>
                            )}
                          </li>
                        )}
                      {stateShow.courseOutDescription === false && (
                        <>
                          {formValues.courseOutDescription === "" && (
                            <span style={{ color: "#000000", fontWeight: 500 }}>
                              Please fill out course courseOutDescription
                            </span>
                          )}
                        </>
                      )}
                    </ul>

                    {stateShow.courseOutDescription === true && (
                      <>
                        <TextEditor
                          formState={formValues.courseOutDescription}
                          history={props.history}
                          handleEditorStateChange={handleEditorStateChange(
                            "courseOutDescription"
                          )}
                        />
                      </>
                    )}
                  </div>
                )}
                <div className="editContainer">
                  <button
                    className="courseEdit-content"
                    onClick={() =>
                      setStateShow((stateShow) => ({
                        ...stateShow,
                        description: !stateShow.description,
                      }))
                    }
                  >
                    {stateShow.description ? "Update -" : "Edit +"}
                  </button>

                  <div className="edit-section-title">Course Description</div>
                  <ul>
                    {stateShow.description === false &&
                      formValues.description !== "" && (
                        <li>
                          {formValues.description && (
                            <div
                              className="rich-text"
                              dangerouslySetInnerHTML={{
                                __html: formValues.description,
                              }}
                            ></div>
                          )}
                        </li>
                      )}
                    {stateShow.description === false && (
                      <>
                        {formValues.description === "" && (
                          <span style={{ color: "#000000", fontWeight: 500 }}>
                            Please fill out course description
                          </span>
                        )}
                      </>
                    )}
                  </ul>

                  {stateShow.description === true && (
                    <>
                      <TextEditor
                        formState={formValues.description}
                        history={props.history}
                        handleEditorStateChange={handleEditorStateChange(
                          "description"
                        )}
                      />
                    </>
                  )}
                </div>

                {formValues.courseType !== "liveCourse" && (
                  <>
                    <div className="editContainer li-list-style-alpha">
                      <button
                        className="courseEdit-content"
                        onClick={() =>
                          setStateShow((stateShow) => ({
                            ...stateShow,
                            Faqs: !stateShow.Faqs,
                          }))
                        }
                      >
                        {stateShow.Faqs ? "Update -" : "Edit +"}
                      </button>

                      <div className="edit-section-title">Course Faqs</div>
                      <ul className="course-FaqsUL">
                        {stateShow.Faqs === false && (
                          <>
                            {formValues.faqs &&
                              formValues.faqs[0]?.question !== "" &&
                              formValues.faqs
                                .slice(0, numberOfFaqs)
                                .map((faqs, index) => (
                                  <div key={index}>
                                    <li>Question: {faqs.question}</li>
                                    <li>Answer: {faqs.answer}</li>
                                  </div>
                                ))}
                          </>
                        )}
                        {formValues?.faqs?.length > 2 && (
                          <button
                            className="exapnd-courseHighLights ml-4"
                            onClick={handleFaqsExpand}
                          >
                            {showMoreFaqs ? "- Read less" : "+ Read more"}
                          </button>
                        )}
                      </ul>
                      {stateShow.Faqs === false && (
                        <>
                          {formValues.faqs[0]?.question === "" && (
                            <span style={{ color: "#000000", fontWeight: 500 }}>
                              Please fill out course Faqs
                            </span>
                          )}
                        </>
                      )}
                      {stateShow.Faqs === true && (
                        <div className="define-add-input">
                          {formValues.faqs.map((element, index) => (
                            <div className="form-inline" key={index}>
                              <label htmlFor="question">
                                Question {index + 1}
                              </label>
                              <input
                                type="text"
                                name="question"
                                placeholder={`FAQ's question ${index + 1}`}
                                value={element.question}
                                onChange={({ target }) =>
                                  handleInputChange(
                                    index,
                                    "faqs",
                                    target.value,
                                    target.name
                                  )
                                }
                              />
                              <label htmlFor="answer">Answer</label>
                              <input
                                type="text"
                                name="answer"
                                placeholder={`FAQ's answer ${index + 1}`}
                                value={element.answer}
                                onChange={({ target }) =>
                                  handleInputChange(
                                    index,
                                    "faqs",
                                    target.value,
                                    target.name
                                  )
                                }
                              />

                              {index > 0 ? (
                                <img
                                  name="faqs"
                                  href="javascript(void);"
                                  className="align-textRemove faq"
                                  onClick={(event) =>
                                    removeFormFields(
                                      event,
                                      index,
                                      event.target.name
                                    )
                                  }
                                  src={`${process.env.REACT_APP_SMIK_API_BASEURL}/icons/icon-trash.svg`}
                                  alt=""
                                />
                              ) : null}
                            </div>
                          ))}
                          <div className="define-add-text">
                            <a
                              href="javascript(void);"
                              onClick={(event) =>
                                addFormFields(
                                  event,
                                  "faqs",
                                  10,
                                  {
                                    ...formValues,
                                    faqs: formValues.faqs.map(
                                      ({ question, answer }) => ({
                                        question,
                                        answer,
                                      })
                                    ),
                                  },
                                  errors,
                                  {
                                    question: "",
                                    answer: "",
                                  },
                                  true
                                )
                              }
                            >
                              + Add More Fields
                            </a>
                          </div>
                        </div>
                      )}
                    </div>

                  </>
                )}

                {!bundle && (
                  <div className="editContainer">
                    <button
                      className="courseEdit-content"
                      onClick={() =>
                        setStateShow((stateShow) => ({
                          ...stateShow,
                          category: !stateShow.category,
                        }))
                      }
                    >
                      {stateShow.category ? "Edit +" : "Update -"}
                    </button>

                    <div className="edit-section-title">Course Category</div>
                    {stateShow.category === false && (
                      <>
                        <div className="courseCategory-select">
                          <Dependent
                            selectionHandler={handledependent}
                            category={formValues.category}
                            subCategory={formValues.subCategory}
                          />
                        </div>
                      </>
                    )}

                    {/* {stateShow.category === true && (
                      <>
                        {`${formValues.category} ${" "}
                        ${formValues.subCategory}
                        `}
                      </>
                    )} */}
                    {stateShow.category === true && (
                      <>
                        {`${formValues.category} ${" "}
                        `}
                      </>
                    )}
                  </div>
                )}

                <div className="editContainer">
                  <button
                    className="courseEdit-content"
                    onClick={() =>
                      setStateShow((stateShow) => ({
                        ...stateShow,
                        level: !stateShow.level,
                      }))
                    }
                  >
                    {stateShow.level ? "Edit +" : "Update -"}
                  </button>

                  <div className="edit-section-title">Course Level</div>
                  {stateShow.level === false && (
                    <>
                      <div className="courseCategory-select">
                        <select
                          disabled={stateShow.level ? true : false}
                          aria-label="Course Level"
                          defaultValue={formValues.level}
                          name="level"
                          onChange={(event) =>
                            setFormValues({
                              ...formValues,
                              [event.target.name]: event.target.value,
                            })
                          }
                        >
                          <option>Select level of this Course</option>

                          {selectLevelOptions.map((option) => (
                            <option key={option.value} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    </>
                  )}
                  {stateShow.level === true && <>{formValues.level}</>}
                </div>

                {formValues.courseType !== "liveCourse" && (
                  <>
                    <div className="editContainer">
                      <button
                        className="courseEdit-content"
                        onClick={() =>
                          setStateShow((stateShow) => ({
                            ...stateShow,
                            language: !stateShow.language,
                          }))
                        }
                      >
                        {stateShow.language ? "Update -" : "Edit +"}
                      </button>
                      <div className="edit-section-title">Language :</div>
                      {stateShow.language === true && (
                        <>
                          <div className="courseCategory-select">
                            <select
                              aria-label="language"
                              className="category"
                              id="Category"
                              defaultValue={formValues.language}
                              name="language"
                              onChange={(event) =>
                                setFormValues({
                                  ...formValues,
                                  [event.target.name]: event.target.value,
                                })
                              }
                            >
                              <option>choose a Language</option>
                              {chooseLanguageOptions.map((option) => (
                                <option key={option.value} value={option.value}>
                                  {option.label}
                                </option>
                              ))}
                            </select>
                          </div>
                        </>
                      )}

                      {stateShow.language === false && (
                        <>{formValues.language}</>
                      )}
                    </div>

                    <div className="editContainer">
                      <button
                        className="courseEdit-content"
                        onClick={() =>
                          setStateShow((stateShow) => ({
                            ...stateShow,
                            duration: !stateShow.duration,
                          }))
                        }
                      >
                        {stateShow.duration ? "Update -" : "Edit +"}
                      </button>
                      <div className="edit-section-title">Duration (in hrs)</div>
                      {stateShow.duration == true && (
                        <>
                          <div className="courseGetContent-subClass">
                            <>
                              <input
                                type="number"
                                onKeyDown={(event) => checkIfNumber(event)}
                                className="hours"
                                aria-label="duration"
                                name="duration"
                                placeholder="Please fill out Course Duration"
                                value={formValues.duration}
                                onChange={({ target }) => handle(target)}
                                disabled={stateShow.duration ? false : true}
                              />
                              <label className="hour-text">Hours</label>
                            </>
                          </div>
                          <span className="num-error-msg-show">
                            {numError !== "" && numError}
                          </span>
                        </>
                      )}

                      {stateShow.duration === false && (
                        <>
                          <>
                            {formValues.duration === "" && (
                              <span style={{ color: "#000000" }}>
                                Please fill out course duration
                              </span>
                            )}
                            {formValues.duration}
                          </>
                        </>
                      )}
                    </div>

                    <div className="editContainer">
                      <button
                        className="courseEdit-content"
                        onClick={() =>
                          setStateShow((stateShow) => ({
                            ...stateShow,
                            courseDate: !stateShow.courseDate,
                          }))
                        }
                      >
                        {stateShow.courseDate ? "Update -" : "Edit +"}
                      </button>
                      <div className="edit-section-title">Closing Date</div>
                      {stateShow.courseDate == true && (
                        <>
                          <div className="courseGetContent-subClass">
                            <>
                              <input
                                type="date"
                                className="closedate"
                                aria-label="closedate"
                                name="courseDate"
                                value={formValues.courseDate ? moment(formValues.courseDate).format("YYYY-MM-DD") : ""}
                                onChange={({ target }) => handle(target)}
                                disabled={stateShow.courseDate ? false : true}
                              />
                            </>
                          </div>
                        </>
                      )}

                      {stateShow.courseDate === false && (
                        <>
                          <>
                            {/* {formValues.courseDate === "" && (
                              <span style={{ color: "#000000" }}>
                                Please fill out course closeDate
                              </span>
                            )} */}
                            {formValues.courseDate}
                          </>
                        </>
                      )}
                    </div>

                  </>
                )}

                <div className="editContainer">
                  <button
                    className="courseEdit-content"
                    onClick={() =>
                      setStateShow((stateShow) => ({
                        ...stateShow,
                        price: !stateShow.price,
                      }))
                    }
                  >
                    {stateShow?.price ? "Update -" : "Edit +"}
                  </button>

                  <div className="align-top">
                    <div className="define-page">
                      <h3 className="edit-section-title">
                        {CourseBuilderStaticData.step17.header1}
                      </h3>
                      {stateShow.price === true && (
                        <>
                          <p>{CourseBuilderStaticData.step17.subHeader1}</p>
                          {!bundle && (
                            <div className="price-section">
                              <input
                                aria-label="price selection"
                                type="checkbox"
                                checked={formValues.isFree}
                                onChange={() => {
                                  setFormValues({
                                    ...formValues,
                                    isFree: !formValues.isFree,
                                  });
                                }}
                              />
                              <p>{CourseBuilderStaticData.step17.subHeader2}</p>
                            </div>
                          )}

                          {!formValues.isFree && (
                            <div>
                              <div className="price-inner-cost">
                                <div className="define-add-input price-inner-cost-inner">
                                  <input
                                    type="text"
                                    name="enrollmentFee"
                                    id="enrollmentFee"
                                    value="INR"
                                    readOnly
                                  />
                                </div>
                                <div className="define-add-input price-inner-cost-inner">
                                  <input
                                    type="number"
                                    placeholder="Enter your price"
                                    name="enrollmentFee"
                                    disabled={
                                      stateShow.price && stateShow.price
                                        ? false
                                        : true
                                    }
                                    id="enrollmentFee"
                                    value={
                                      formValues.enrollmentFee !== 0 &&
                                      formValues.enrollmentFee
                                    }
                                    onChange={({ target }) =>
                                      setFormValues({
                                        ...formValues,
                                        enrollmentFee: target.value,
                                      })
                                    }
                                  />
                                </div>
                              </div>
                              <h4>{CourseBuilderStaticData.step17.header2}</h4>
                              {/* <p>
                                {CourseBuilderStaticData.step17.subHeader3}{" "}
                              </p> */}
                              {/* <div className="price-inner-cost-inner">
                                <select
                                  aria-label="Category"
                                  className="category"
                                  id="Category"
                                  name="Category"
                                  disabled={
                                    stateShow.price && stateShow.price
                                      ? false
                                      : true
                                  }
                                  value={formValues.promotionalOffer}
                                  onChange={({ target }) => {
                                    setFormValues({
                                      ...formValues,
                                      promotionalOffer: target.value === "true",
                                      promotionalCode:
                                        target.value === "true"
                                          ? formValues.promotionalCode
                                          : "",
                                    });
                                  }}
                                >
                                  <option value="" hidden>
                                    Discount promo CODE
                                  </option>
                                  <option value="true">
                                    Yes, I want a code
                                  </option>
                                  <option value="false">
                                    No, I do not want a code
                                  </option>
                                </select>
                              </div>
                              {formValues.promotionalOffer ? (
                                <div className="define-add-input price-inner-cost-inner-promocode">
                                  <input
                                    type="text"
                                    placeholder="Enter your Promotional code"
                                    name="price"
                                    value={formValues.promotionalCode}
                                    disabled={
                                      stateShow.price && stateShow.price
                                        ? false
                                        : true
                                    }
                                    onChange={({ target }) =>
                                      setFormValues({
                                        ...formValues,
                                        promotionalCode: target.value,
                                      })
                                    }
                                  />
                                </div>
                              ) : null}

                              <p>
                                Want percentage discount for this course do you
                                want to offer?
                              </p>
                              <div className="define-add-input price-inner-cost-inner">
                                <input
                                  type="text"
                                  placeholder="Percentage"
                                  name="percentage"
                                  value={formValues.discountPercent}
                                  onChange={({ target }) =>
                                    setFormValues({
                                      ...formValues,
                                      discountPercent: target.value,
                                    })
                                  }
                                />
                              </div> */}
                            </div>
                          )}
                        </>
                      )}
                    </div>
                    {stateShow.price === false && (
                      <>
                        {formValues.price}
                        {formValues.currency}
                        {formValues.enrollmentFee}
                      </>
                    )}
                  </div>
                </div>
                {!bundle && (
                  <div className="editContainer" style={{ position: "relative" }}>
                    <button
                      className="courseEdit-content"
                      onClick={() =>
                        setStateShow((stateShow) => ({
                          ...stateShow,
                          Syallbus: !stateShow.Syallbus,
                        }))
                      }
                    >
                      {stateShow.Syallbus ? "Update -" : "Edit +"}
                    </button>
                    <div className="edit-section-title">
                      Course Syllabus Document
                    </div>

                    {stateShow.Syallbus === false ? (
                      <div className="syllabus-display-card mt-3">
                        {formValues.syllabusFile ? (
                          <div className="flex items-center gap-4 p-4 bg-blue-50/40 rounded-2xl border border-blue-100/50 hover:bg-blue-50/60 transition-all duration-300">
                            <div className="w-12 h-12 bg-white rounded-xl shadow-xs flex items-center justify-center border border-blue-100 flex-shrink-0">
                              <img
                                src="https://cdn-icons-png.freepik.com/512/174/174339.png"
                                width="32"
                                height="32"
                                alt="Syllabus Document"
                              />
                            </div>
                            <div className="min-w-0 flex-1">
                              <p className="text-sm font-bold text-slate-800 truncate leading-snug">
                                {formValues.syllabusFile}
                              </p>
                              {formValues.Syallbus?.[0]?.fileName && (
                                <a
                                  href={getS3URL(formValues.Syallbus[0].fileName)}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="text-xs text-blue-600 font-semibold hover:text-blue-700 hover:underline mt-1 inline-flex items-center gap-1"
                                >
                                  View / Download Document &rarr;
                                </a>
                              )}
                            </div>
                          </div>
                        ) : (
                          <div className="p-4 bg-slate-50 rounded-2xl border border-slate-100 border-dashed text-center text-slate-400 text-sm italic">
                            No syllabus document uploaded. Click Edit to upload.
                          </div>
                        )}
                      </div>
                    ) : (
                      <div className="syllabus-edit-wrapper mt-3 p-5 bg-slate-50/50 border border-slate-100 rounded-3xl">
                        <p className="text-xs text-slate-400 font-medium mb-4 leading-relaxed">
                          Upload a syllabus document (PDF, DOCX, or Excel). Students will be able to download this document on the landing page.
                        </p>
                        <div className="form-inline bg-white p-4 border border-slate-100 rounded-2xl shadow-xs">
                          <CourseFile
                            courseFileLimit={1}
                            courseFile={CourseFileHandler}
                            courseId={courseId}
                          />
                        </div>
                        {formValues.syllabusFile && (
                          <div className="mt-3 text-xs text-slate-500 bg-emerald-50/50 border border-emerald-100/50 p-2.5 rounded-xl flex items-center gap-2">
                            <span className="w-2 h-2 rounded-full bg-emerald-500" />
                            <span className="font-bold text-emerald-800">Pending Update:</span>
                            <span className="truncate text-slate-600">{formValues.syllabusFile}</span>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                )}

              {!bundle && (
                <>
                  <div className="edit-section-title pt-5">
                    Course Sections
                  </div>
                  {formValues?.courseSections?.length > 0 &&
                    formValues.courseSections.map(
                      (
                        {
                          name,
                          description,
                          files,
                          scroms,
                          id,
                          courseID,
                          isEdit,
                          videoLink,
                        },

                        index
                      ) => (
                        <EditableChapter
                          title={name}
                          // key={id || currentIndex}
                          //mainTitle={mainTitle}
                          content={description}
                          files={files}
                          scroms={scroms}
                          id={id}
                          history={props.history}
                          videoLink={videoLink}
                          formValues={formValues}
                          setFormValues={setFormValues}
                          handleEditorStateChange={handleEditorStateChange}
                          handleInputChange={handleInputChange}
                          courseSectionId={id}
                          index={index}
                          handle={handle}
                          courseID={courseID}
                          add={isEdit}
                          fetchAll={fetchAll}
                          removeFormFields={removeFormFields}
                          courseFile={courseFile(
                            index, formValues
                          )}
                          setSelectedSyllabus={setSelectedSyllabus}
                          selectedSyllabus={selectedSyllabus}
                        />
                      )
                    )}
                </>
                // <>
                //   {formValues?.courseSections &&
                //     (() => {
                //       let globalIndex = 0; // Global counter outside the map

                //       return Object.entries(
                //         formValues.courseSections.reduce((acc, section) => {
                //           const syllabus = section.syllabusName || "Ungrouped";
                //           if (!acc[syllabus]) acc[syllabus] = [];
                //           acc[syllabus].push(section);
                //           return acc;
                //         }, {})
                //       ).map(([syllabusName, sections], groupIndex) => (
                //         <div key={groupIndex} className="mb-6">
                //           <h3 className="text-xl font-bold text-blue-600 mb-4">
                //             Syllabus: {syllabusName}
                //           </h3>

                //           {sections.map(
                //             (
                //               {
                //                 // mainTitle,
                //                 name,
                //                 description,
                //                 files,
                //                 scroms,
                //                 id,
                //                 courseID,
                //                 isEdit,
                //                 videoLink,
                //               },
                //               sectionIndex
                //             ) => {
                //               const currentIndex = globalIndex++; // Increment global index

                //               return (
                //                 <EditableChapter
                //                   key={id || currentIndex}
                //                   // mainTitle={mainTitle}
                //                   title={name}
                //                   content={description}
                //                   files={files}
                //                   scroms={scroms}
                //                   id={id}
                //                   history={props.history}
                //                   videoLink={videoLink}
                //                   formValues={formValues}
                //                   setFormValues={setFormValues}
                //                   handleEditorStateChange={handleEditorStateChange}
                //                   handleInputChange={handleInputChange}
                //                   courseSectionId={id}
                //                   index={currentIndex} // Unique index across all sections
                //                   handle={handle}
                //                   courseID={courseID}
                //                   add={isEdit}
                //                   fetchAll={fetchAll}
                //                   removeFormFields={removeFormFields}
                //                   courseFile={courseFile(currentIndex, formValues)}
                //                   setSelectedSyllabus={setSelectedSyllabus}
                //                   selectedSyllabus={selectedSyllabus}
                //                 />
                //               );
                //             }
                //           )}
                //         </div>
                //       ));
                //     })()}
                // </>


              )}

              {formValues.courseType !== "liveCourse" && (
                <>
                  {!bundle && (
                    <>
                      {formValues?.courseSections?.length < 200 && (
                        <div className="innerQuiz-button addCourse-Section">
                          <button
                            className="btn-3 create-question addNewSection"
                            onClick={(event) =>
                              addFormFields(
                                event,
                                "courseSections",
                                200,
                                {
                                  ...formValues,
                                  courseSections: [
                                    ...formValues.courseSections.map(
                                      ({ name, description }) => ({
                                        name,
                                        description:
                                          JSON.stringify(description),
                                      })
                                    ),
                                  ],
                                },
                                errors,
                                {
                                  name: "",
                                  description: null,
                                  files: [],
                                  videoLink: "",
                                },
                                true
                              )
                            }
                          >
                            Add New Section +
                          </button>
                        </div>
                      )}
                    </>
                  )}
                </>
              )}

              {formValues.courseType !== "liveCourse" && (
                <>
                  {!bundle && (
                    <div className="accordion-item-1 border-bottom-accordion">
                      <div className="accordion-title  mycoursedetails pt-4 mb-8">
                        <div>Course Quiz</div>
                        <div className="expn-elte-btn">
                          {/* <button
                              className="course-chapter-expand"
                              onClick={handleraccordion}
                            >
                              {isActive ? "Collapse" : "Expand"}
                            </button> */}
                          <button
                            className="course-chapter-expand mr-4"
                            onClick={handleChangeEdit}
                          >
                            Edit
                          </button>
                        </div>
                      </div>
                      {/* {isActive && (
                          <div className="accordion-content border-top-content">
                            <div className="">
                              <div>
                                <div className="">
                                  <Quiz
                                    setQuizCreation={setQuizCreation}
                                    quizCreation={quizCreation}
                                    setQuizValidateMsg={setQuizValidateMsg}
                                    quizValidateMsg={quizValidateMsg}
                                    updateQuizResponse={updateQuizResponse}
                                  />
                                  {!isQuizPopupVisible && (
                                    <>
                                      <div className="innerQuiz-button">
                                        {!quizResponse ? (
                                          quizCreation?.questions?.every(
                                            (item) =>
                                              item?.question !== null &&
                                              item?.answers?.every(
                                                (data) => data?.answer !== ""
                                              )
                                          ) ? (
                                            <button
                                              className="btn-3 create-question quizUpdate"
                                              onClick={quizSubmitHandler}
                                            >
                                              Update Quiz
                                            </button>
                                          ) : (
                                            <button
                                              className="btn-3 create-question quizUpdate-disabled"
                                              disabled
                                            >
                                              Update Quiz
                                            </button>
                                          )
                                        ) : (
                                          <Loading />
                                        )}
                                      </div>
                                    </>
                                  )}
                                  {isQuizPopupVisible && (
                                    <div className="quiz-eveny-0">
                                      <div
                                        className="quiz-popup"
                                        onClick={() =>
                                          setIsQuizPopupVisible(
                                            !isQuizPopupVisible
                                          )
                                        }
                                      >
                                        <i className="icon check"></i>
                                      </div>
                                      <p>{updateQuizResponse}</p>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        )}

                        {showCoursePreview && (
                          <OverlayContainer>
                            <CoursePreview
                              courseName={formValues.courseName}
                              courseImg={
                                formValues.imageFiles[0] &&
                                getS3URL(formValues.imageFiles[0].fileName)
                              }
                              courseVid={getS3URL(
                                formValues.videoFiles[0].fileName
                              )}
                              toogle={setShowCoursePreview}
                            />
                          </OverlayContainer>
                        )} */}
                    </div>
                  )}
                </>
              )}

              {formValues.courseType === "liveCourse" && (
                <div className="accordion-item-1 border-bottom-accordion">
                  <div className="accordion-title  mycoursedetails">
                    <div>Webinar Scheduler </div>
                    <div className="expn-elte-btn">
                      <button
                        className="course-chapter-expand"
                        onClick={() =>
                          setStateShow((stateShow) => ({
                            ...stateShow,
                            WebinarScheduler: !stateShow.WebinarScheduler,
                          }))
                        }
                      >
                        {stateShow.WebinarScheduler ? "Collapse" : "Expand"}
                      </button>
                    </div>
                  </div>
                  {stateShow.WebinarScheduler && (
                    <div className="editWebniar">
                      <WebinarScheduler
                        history={props}
                        schedule={setFormValues}
                        formValues={formValues}
                        current={null}
                      />
                    </div>
                  )}
                </div>
              )}

              {bundle && (
                <div className="editContainer">
                  <button
                    className="courseEdit-content"
                    onClick={() =>
                      setStateShow((stateShow) => ({
                        ...stateShow,
                        selectedCourse: !stateShow.selectedCourse,
                      }))
                    }
                  >
                    {stateShow.selectedCourse ? "Update -" : " Edit +"}
                  </button>

                  <div className="edit-section-title">
                    Bundle Selected Courses
                  </div>
                  <ul>
                    <div>
                      {formValues &&
                        formValues?.courses &&
                        formValues?.courses.length > 0 &&
                        formValues?.courses?.map((ele, item) => (
                          <div
                            key={item}
                            className="border-bottom-courseBundle "
                          >
                            <div
                              className="main-conatiner-course-bundle"
                              style={{ width: "100%" }}
                            >
                              <div>
                                <h4 className="bundle-Section">
                                  {ele.CourseName}
                                </h4>
                                <div className="courseSelected-flex">
                                  <div>{ele.Category}</div>
                                  <p>
                                    <strong>Duration:</strong>
                                    {ele.Duration === ""
                                      ? "Duration Not found"
                                      : `${ele.Duration} hrs`}
                                  </p>
                                  <p>
                                    <strong>Language:</strong>
                                    {ele.Language}
                                  </p>
                                  <p>
                                    <strong>Subtitles:</strong>English
                                  </p>
                                </div>
                              </div>
                              <div>
                                <img
                                  src={`${process.env.REACT_APP_LOGIN_API_BASEURL}/icons/icon-complete-check.svg`}
                                  width={"20px"}
                                />
                              </div>
                            </div>
                          </div>
                        ))}
                    </div>
                  </ul>
                  {stateShow.selectedCourse && (
                    <div className="createBundleContainer-Section">
                      <CreateBundle
                        selectedCourses={formValues}
                        setselectedCourses={setFormValues}
                        editbundle={true}
                      />
                    </div>
                  )}
                </div>
              )}
            </div>

            {stateShow.saveall && (
              <EditSubmit
                popup={isPopupVisible}
                success={success}
                warning={warning}
                closeHandler={closeHandler}
                editResponse={editedCourseResponse}
              />
            )}
          </section>
    </>
  )
      )}
    </>
  );
};
export default CourseEdit;
